import React, { useState } from "react";
import { Grid, Typography, Button, Link, Container, Alert, AlertTitle } from "@mui/material";
import Email from "../../common/fields/Email";
import { forgot } from "../../../services/LoginService";
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

const Forgot = () => {
  const [responseForgot, setResponseForgot] = useState(null);
  const [errors, setErrors] = useState({
    status: {
      user: false,
      userMatch: false,
    },
    text: {
      user: "",
      userMatch: "",
    },
  });
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    const trimmedEmail1 = email1.trim();
    const trimmedEmail2 = email2.trim();

    const emailRegex = /^([A-Za-z0-9+_.-]+)@([\da-zA-Z.-]+)\.+([a-zA-Z.]{2,6})$/;
    const emailError = trimmedEmail1 === "" || !emailRegex.test(trimmedEmail1);
    const emailMatchError = trimmedEmail1 !== trimmedEmail2;

    setErrors({
      status: {
        user: emailError,
        userMatch: emailMatchError,
      },
      text: {
        user: emailError ? "Enter a valid email address" : "",
        userMatch: emailMatchError ? "Emails do not match" : "",
      },
    });

    if (emailError || emailMatchError) {
      return;
    }
    const form = { email: trimmedEmail1 };
    setLoading(true);

    try {
      const status = await forgot(form);
      setResponseForgot(status);
    } catch (err) {
      setResponseForgot(500);
    } finally {
      setLoading(false);
    }
  };

  if (responseForgot === 202) {
    return (
      <Container maxWidth="sm" className="mx-auto">
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={4}
          sx={{ minHeight: "60vh", textAlign: "center", mt: 8 }}
        >
          <Grid item>
            <MarkEmailReadRoundedIcon
              color="primary"
              sx={{ fontSize: 64 }}
            />
          </Grid>

          <Grid item>
            <Typography variant="h4" gutterBottom>
              Check your inbox
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: "400px", mx: "auto" }}>
              We've sent you an email with a link to reset your password.
              If you don’t see it soon, please check your spam or junk folder.
            </Typography>
          </Grid>

          <Grid item>
            <Button
              href="/login"
              variant="outlined"
              size="large"
            >
              Back to Login
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" className="loginPageContainer">
      <div className="loginPageContainer">
        <form className="form" noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <div className="loginTitles">
                <div className="title">
                  Forgot your Password?
                </div>
                <div className="subtitle">
                  Use the form below to recover it.
                </div>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={6}>
            <Grid item xs={12} md={12} lg={12}>
              <div style={{ marginBottom: 16 }}>
                <Email
                  id="email1"
                  label="Email"
                  name="email"
                  placeholder="Email here..."
                  defaultValue={""}
                  disabled={loading}
                  error={errors.status.user}
                  errorText={errors.text.user}
                  classNameCustom={"textField"}
                  autoComplete="email"
                  required={true}
                  onChange={(e) => setEmail1(e.target.value)}
                />
              </div>
              <div >
                <Email
                  id="email2"
                  label="Repeat e-mail"
                  name="email"
                  placeholder="Email here..."
                  defaultValue={""}
                  disabled={loading}
                  error={errors.status.userMatch}
                  errorText={errors.text.userMatch}
                  classNameCustom={"textField"}
                  autoComplete="email"
                  required={true}
                  onChange={(e) => setEmail2(e.target.value)}
                />
              </div>
            </Grid>
          </Grid>

          {responseForgot && responseForgot !== 202 && (
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12} md={10}>
                <Alert
                  severity="error"
                  icon={<ErrorOutlineRoundedIcon fontSize="small" />}
                  sx={{
                    borderRadius: 2,
                    fontSize: '0.95rem',
                    alignItems: 'center',
                    py: 1.5,
                  }}
                >
                  {responseForgot === 404
                    ? "We couldn't find an account associated with that email address."
                    : "We were unable to process your request. Please try again later or contact an administrator."}
                </Alert>
              </Grid>
            </Grid>
          )}

          <br />
          <hr />
          <div className="buttons-container">
            <Button
              component={Link}
              href={"/login"}
              variant="text"
              className="mr-1"
              size="medium"
            >
              Back to Login
            </Button>

            <Button
              onClick={send}
              variant="contained"
              color="primary"
              className="submit"
              size="large"
              disabled={loading}
            >
              {loading ? "Sending..." : "Reset my password"}
            </Button>
          </div>
        </form>

      </div>
    </Container>
  );
};

export default Forgot;
